import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, Form, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { UserService } from 'src/app/services/user.service';
import { Store } from '@ngrx/store';
import * as FormActions from '../../reducers/actions/forms.actions';
import { MatDialog, MatSnackBar } from '@angular/material';
import { PerfilComponent } from '../perfil/perfil.component';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';
import { PagoService } from 'src/app/services/pago.service';
import { GLOBAL } from 'src/app/services/global';
import { BehaviorSubject } from 'rxjs';
import { FileUploader } from 'ng2-file-upload';
import { DocumentoService } from 'src/app/services/documento.service';
import { Router } from '@angular/router';
import { DataTransferService } from 'src/app/services/dataTransfer.service';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';

declare const swal: any;
//archivos
const url = GLOBAL.url;
declare var jQuery: any;
declare var $: any;
const uri = url + 'upload/file';

///archivos
interface AppState {
  form: Form;
}

@Component({
  selector: 'app-ingreso-observaciones',
  templateUrl: './ingreso-observaciones.component.html',
  styleUrls: ['./ingreso-observaciones.component.css'],
  providers: [Seguimiento_exp_Service, UserService, DocumentoService, DataTransferService]
})
export class IngresoObservacionesComponent implements OnInit {

  @ViewChild('openModalPago') openModalPago: TemplateRef<any>;
  @ViewChild('ingreso_sol') ingreso_sol: TemplateRef<any>;
  @ViewChild('openModalPago') openModalPagoFinal: TemplateRef<any>;
  @ViewChild('pagoInProcess') pagoInProcess: TemplateRef<any>;
  @ViewChild('buscar_sol') buscar_sol: TemplateRef<any>;
  @ViewChild('mod_solicitante') mod_solicitante: TemplateRef<any>;

  public global = GLOBAL

  formderecho
  calculo
  identity
  token
  buscando = false
  nuevo_sol_derecho = false

  info_observacion
  observaciones = []
  id_carro
  carro_prueba
  _pagoxml
  dirs
  info_rut
  valores_cert_noformat
  derecho_buscado = false

  info_mod
  infoPago

  //forms
  public rut = new FormControl('');
  public rol = new FormControl('');
  public dir = new FormControl('');
  public num = new FormControl('');
  public correo = new FormControl('');
  public nombre = new FormControl('');
  public telefono = new FormControl('');
  public url_fracaso = new FormControl('');
  public url_exito = new FormControl('');

  solicitante
  folio
  registro_sol: FormGroup;
  mod_sol_form: FormGroup;
  buscar_sol_form: FormGroup;
  rut_encontrado
  continuar = false
  solicitud
  btnDisabled = true
  public esReitero = false


  ////archivos

  panelOpenState = false;

  @ViewChild('modalArchivos') modalArchivos: TemplateRef<any>;
  @ViewChild('modalAdjuntos') modalAdjuntos: TemplateRef<any>;

  uploader: FileUploader = new FileUploader({ url: uri })
  attachmentList: any = [];
  public hasBaseDropZoneOver: boolean = false;
  public hasOnFileDrop: boolean = false;
  public inputList = [];
  labelDrop
  inputValue
  form
  isReady = false;
  public archivosForm
  public archivosSubidos = [];
  public archivoSubidoFind = false;
  public cantArSubidosObligatorios = 0;
  public arrayArchivos = [];
  public interval
  private pdfUrl = GLOBAL.pdfUrl;
  public generico = GLOBAL.generico;
  public adjuntoActual
  public enableUpload = false
  public enableUploadnum = false
  public adjuntos = []
  public files = []
  public rows = []
  public rows1 = [{ total: 0 }]
  public documentoNombre = ''
  public numeroObservacion = ''
  public maxSizeFiles = 75000000
  public actualSizeFiles = 0
  public fecha_noti
  public fecha_crea

  //archivos lista
  nombreForm;
  nombreArchivo;
  inputdatos = [];
  storageDatos = [];
  doc1;
  doc2;
  doc3;
  doc4;
  doc5;
  doc6;
  public demolicion_archivo;
  public test = true
  documents
  docsDetectChange = new BehaviorSubject([])
  cargando = true
  archivoCargado
  btnAccept = false
  peso
  pase = false
  glosa = new FormControl('', Validators.required);
  linkarchivos



  constructor(private _documentosServices: DocumentoService, private _fb: FormBuilder, private rutValidator: RutValidator, private userService: UserService, private spinner: NgxSpinnerService, private store: Store<AppState>, private dialog: MatDialog, private _snackBar: MatSnackBar
    , private _formBuilder: FormBuilder, private _router: Router, private _dataService: DataTransferService, private _seguimientoService: Seguimiento_exp_Service) {

    this.info_observacion = ""
    this.buscando = false
    this.formderecho = this._fb.group({
      rut: ["", [Validators.required, this.rutValidator]],
      expediente: [""],
      solicitud: [""]
    })

    this.buscar_sol_form = this._fb.group({
      rut: ["", [Validators.required, this.rutValidator]],
    })


    ////archivos

    this.nombreArchivo = ''
    this.demolicion_archivo = localStorage.getItem("archivo_demolicion")

    if (!JSON.parse(localStorage.getItem("adjuntos"))) {
      localStorage.setItem("adjuntos", JSON.stringify(this.adjuntos));
    } else {
      this.adjuntos = JSON.parse(localStorage.getItem("adjuntos"));
    }
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false
    }

    this.uploader.onCompleteItem = (item: any, response: any, status: any, headers: any) => {
      console.log('onCompleteitem response:', response);
      this.attachmentList.push(response);
    }

  }

  /* Informacion desde seguimiento en caso de ser reitero */
  public id_soL = ""
  public solicitudNum = ""
  public actReiteros = ""
  public tipo = ""
  public fechaCreacion = ""
  public fechaNotificacion = ""

  ngOnInit() {

    /* Datos que vienen desde seguimiento */
    var dataService = JSON.parse(localStorage.getItem("dataTransferO"))
    console.log("dataService", dataService)

    if (dataService) {
      this.buscando = true
      if (dataService.depto == "EDIFICACIÓN") {
        this.formderecho.controls.expediente.setValue(dataService.num) //expediente
      }
      if (dataService.depto == "URBANIZACION" || dataService.depto == "RECEPCIONES") {
        this.formderecho.controls.solicitud.setValue(dataService.num)  //Solicitud
      }
      this.formderecho.controls.rut.setValue(dataService.rut)
      /* console.log(this.formderecho.value) */

      if (dataService.actReiteros) {
        this.esReitero = true

        this.id_soL = dataService.id_soL
        this.solicitudNum = dataService.num
        this.actReiteros = dataService.actReiteros
        this.tipo = dataService.tipo
        this.fechaCreacion = dataService.fechaCreacion
        this.fechaNotificacion = dataService.fechaNotifi

        console.log("Ingreso a observaciones con acta reiteros", dataService.actReiteros)
        this.buscar_observaciones_reitero()
      } else {
        console.log("Ingreso a observaciones")
        this.buscar_observaciones()
      }

      localStorage.removeItem("dataTransferO")

    }
    /*  this._dataService.datos.subscribe(isData => {
       console.log("dataServiceee", isData);
     }); */

    this.identity = this.userService.getIdentity();
    this.token = this.userService.getToken();

    ///archivos


    var intervall
    intervall = setInterval(() => {
      this.documents = JSON.parse(localStorage.getItem("docs_checked"));
      /*  console.log(this.documents)
    */
      if (this.documents) {

        if (this.documents.length > 0) {
          this.llenarTabla()
          clearInterval(intervall)
        }
      }



    }, 5000);
  }

  ngAfterViewChecked() {
    var sol = localStorage.getItem("docs_checkedOK");

    if (sol == "cambiado") {
      this.cargando = true
      localStorage.setItem("docs_checkedOK", "listo")
      console.log("AfterViewChecked, SOL ", sol)

      var x = JSON.parse(localStorage.getItem("docs_checked"));
      /*  console.log(this.documents, x) */
      if (this.documents && x) {

        if (this.documents.length != x.length) {
          this.documents = JSON.parse(localStorage.getItem("docs_checked"));
          this.llenarTabla()
          console.log("los documentos, han cambiado")
        } else {
          for (let index = 0; index < this.documents.length; index++) {
            if (this.documents[index] != x[index]) {
              this.documents = JSON.parse(localStorage.getItem("docs_checked"));
              this.llenarTabla()
              console.log("los documentos, han cambiado")
            }
          }
        }
      }
    }



  }


  llenarTabla() {
    this.rows = []
    this.files = []
    this.actualSizeFiles = 0

    var archivos = localStorage.getItem("archivos_marcados")
    if (archivos) {
      var subidos = { "archivosSubidos": false };
      localStorage.setItem("archivos_marcados", JSON.stringify(subidos));
    }

    console.log('Se llena la tabla')
    var cont = 0
    if (this.documents.length > 0) {


      for (let index = 0; index < this.documents.length; index++) {
        /*  console.log(this.documents[index]) */
        if (this.documents[index].required || this.documents[index].ckeck) {

          if (this.documents[index].required == true || this.documents[index].ckeck == true) {

            this.rows.push({ id: cont, name: this.documents[index].name, new: false })
            cont++;
          }
        }
      }
      /*  console.log(this.rows) */ //este debe sumarse al ultimo 
      this.cargando = false
      this.rows = [...this.rows];
      this.docsDetectChange.next(this.rows)
    }
  }

  cerrarModal() {
    this.nombreArchivo = ''
    this.documentoNombre = ''
    this.dialog.closeAll();
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }
  onFileDrop(e: any, archivo = null) {

    this.archivoSubidoFind = false;
    for (let i = 0; i < this.archivosForm.length; i++) {
      if (this.archivosForm[i].name == archivo.name) {
        this.archivosForm[i].ready = true;
      }
    }
    this.archivosSubidos.push(archivo)
    //console.log(this.archivosSubidos)

    if (this.archivosSubidos) {

      //console.log("entre")

      if (this.arrayArchivos.length == 0) {
        this.arrayArchivos.push(archivo)
        //console.log(this.arrayArchivos)
      } else {

        //console.log("entre en arrayarchivos")
        //console.log(this.arrayArchivos)
        for (let i = 0; i < this.arrayArchivos.length; i++) {
          //console.log(this.arrayArchivos[i])
          //console.log(archivo.name)
          if (this.arrayArchivos[i].name == archivo.name) {

            //console.log("encontre el mismo nombre")
            this.archivoSubidoFind = true;
          }


        }
      }
    }

    if (!this.archivoSubidoFind) {
      this.arrayArchivos.push(archivo)
      if (archivo.obligatorio) {
        this.cantArSubidosObligatorios = this.cantArSubidosObligatorios + 1
        //console.log("this.cantArSubidosObligatorios: ", this.cantArSubidosObligatorios)
        //console.log("Falta subir archivos");

      }
    }



    // for (let i = 0; i < this.inputList.length; i++) {
    //     if(this.inputList[i].name == a){
    //         this.inputList[i].ready = true;
    //     }

    // }
    this.nombreForm = archivo.name;
    this.unir(archivo.name);
    // console.log(e)
    // console.log(nombreArchivo)
    // console.log(a)
    // console.log(this.inputdatos)
    // console.log(this.inputList)
  }

  onInsert(row) {
    /* console.log(row) */
    /* this.revisarTabla() */
    /*  var subidos = { "archivosSubidos": false };
     localStorage.setItem("archivos_marcados", JSON.stringify(subidos)); */
  }

  revisarTabla() {

    var bandera = true
    /*    console.log("revisando tabla", this.rows) */
    for (let tabla = 0; tabla < this.rows.length; tabla++) {
      /*    console.log("Index ", tabla, "bandera ", bandera) */

      if (!this.rows[tabla].archivo || this.rows[tabla].archivo == "") {
        bandera = false
      }

      if ((tabla + 1) == this.rows.length) {
        /*   console.log("Recorri la tabla", bandera) */
        if (bandera == true) {
          this.pase = true
          console.log(this.pase)
        }
      }
    }
    console.log("entre a revisar tabla ", this.pase)
  }

  marcarArchivos() {

    var subidos = { "archivosSubidos": true };
    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
    swal({
      type: 'success',
      title: 'Archivos cargados',
      text: '<p>ya puedes continuar</p>',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false
    }).then(
      () => {
        window.scrollTo(0, document.body.scrollHeight);
      }
    );


  }


  fileInput(archivo) {
    console.log(archivo)

  }




  removeAll() {
    for (let i = 0; i < this.inputList.length; i++) {
      if (this.inputList[i].ready) {
        this.inputList[i].ready = false;
      }
    }
    this.inputdatos.splice(0);

  }

  removeFile(nombre) {

    var index;
    for (let i = 0; i < this.inputdatos.length; i++) {
      if (this.inputdatos[i].nombreArchivo == nombre) {
        for (let x = 0; x < this.inputList.length; x++) {
          if (this.inputList[x].name == this.inputdatos[i].nombreForm) {
            index = i;
            this.inputList[x].ready = false;
          }
        }
      }
    }
    this.inputdatos.splice(index, 1);
  }

  unir(fileType = '') {
    this.uploader.queue[this.uploader.queue.length - 1].file.name = fileType + '-' + new Date().getTime() + '-' + this.uploader.queue[this.uploader.queue.length - 1].file.name
    this.nombreArchivo = this.uploader.queue[this.uploader.queue.length - 1].file.name;
    this.adjuntoActual = this.uploader.queue[this.uploader.queue.length - 1].file.name

    this.inputdatos.push({

      'linkArchivo': `${this.pdfUrl}/${this.nombreArchivo}`,
      'nombreForm': this.nombreForm,
    });
    localStorage.removeItem("archivos")
    //console.log(localStorage.getItem("archivos"))
    localStorage.setItem("archivos", JSON.stringify(this.inputdatos));
    //console.log(localStorage.getItem("archivos"))

  }


  openAdjuntosModal() {
    this.dialog.open(this.modalAdjuntos, { disableClose: true });
  }

  cancelarAdjunto() {
    let tmpName = this.uploader.queue[this.uploader.queue.length - 1].file.name
    this.removeFile(tmpName)
    this.uploader.queue[this.uploader.queue.length - 1].remove()
    localStorage.removeItem("archivos")
    localStorage.setItem("archivos", JSON.stringify(this.inputdatos))
    this.enableUpload = false
    this.enableUploadnum = false
    this.nombreArchivo = ''
  }

  adjuntoSave(fileName = null) {
    var subidos = { "archivos_nuevos": true };
    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
    this.btnAccept = false
    console.log(this.btnAccept)
    console.log(this.rows)

    var id = this.rows.length

    this.rows = this.rows.concat({
      id: id,
      name: this.documentoNombre,
      archivo: this.nombreArchivo,
      num: this.numeroObservacion,
      peso: this.peso,
      new: true
    })

    console.log(this.rows)
    console.log("filesssss", this.files)
    this.rows = [...this.rows];
    this.docsDetectChange.next(this.rows)
    this.peso = ''
    this.archivoCargado = ''
    this.cerrarModal();


  }


  deleteFileAntiguo(index = null) {
    if (index != null) {
      //recalcular size
      let fil: File
      fil = this.files[index]
      this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
      //Remove file
      console.log("files", this.files, "index", index)
      this.files.splice(index, 1)
      let actualRow = localStorage.getItem("adjuntos");
      this.rows = JSON.parse(actualRow);
      this.rows.splice(index, 1)
      localStorage.setItem("adjuntos", JSON.stringify(this.rows));
    } else {
      //recalcular size
      let fil: File
      fil = this.files[this.files.length - 1]
      this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
      //Remove file
      this.files.splice(this.files.length - 1, 1)
      let actualRow = localStorage.getItem("adjuntos");
      this.rows = JSON.parse(actualRow);
      this.rows.splice(this.rows.length - 1, 1)
      localStorage.setItem("adjuntos", JSON.stringify(this.rows));
    }
  }

  handleFileInput(files: FileList) {
    let file: File
    file = files.item(0)
    /* console.log("archivo agregado", file); */
    let actualRow = localStorage.getItem("adjuntos");
    this.rows = JSON.parse(actualRow);
    this.nombreArchivo = files.item(0).name
    /*  console.log("nombre de archivo", this.nombreArchivo); */
    this.files.push({ name: this.documentoNombre, doc: file })
    let peso = (files.item(0).size / 1000000) + ' MB'
    this.peso = (files.item(0).size / 1000000) + ' MB'
    this.rows = this.rows.concat({
      name: this.documentoNombre,
      archivo: this.nombreArchivo,
      num: this.numeroObservacion,
      peso: peso
    })
    /*  console.log("this.files", this.files); */
    localStorage.setItem("adjuntos", JSON.stringify(this.rows));
    this.actualSizeFiles = this.actualSizeFiles + files.item(0).size

    //check max size file
    this.checksSize(this.files.length - 1)
  }


  handleFileInput2(files: FileList, row) {
    let file: File
    file = files.item(0)

    /*  console.log("seleccion", row) */
    console.log("datos tabla", this.rows)
    /* console.log("archivo agregado", file); */
    console.log("archivos cargados", this.files);


    if (row.id || row.id == 0) {
      /*   console.log(row.id) */
      for (let index = 0; index < this.rows.length; index++) {
        /*    console.log(this.rows[index]) */
        if (this.rows[index].id == row.id) {
          /*  console.log(this.rows[index].id) */
          this.nombreArchivo = files.item(0).name
          let peso = (files.item(0).size / 1000000) + ' MB'

          this.rows[index].archivo = this.nombreArchivo
          this.rows[index].num = this.numeroObservacion
          this.rows[index].peso = peso
          this.rows[index].new = false
          this.files[index] = ({ name: this.rows[index].name, doc: file })

          this.checksSize(this.files.length - 1)

          this.revisarTabla()
        }
      }
    } else {
      this.archivoCargado = files.item(0)
      console.log(file)
      if (files.item(0).name && this.documentoNombre != '') {
        this.btnAccept = true
        console.log(this.btnAccept)


        console.log("archivo agregado", file);
        let actualRow = localStorage.getItem("adjuntos");
        /*   this.rows = JSON.parse(actualRow); */
        this.nombreArchivo = files.item(0).name
        console.log("nombre de archivo", this.nombreArchivo);


        /*  this.files.push({ name: this.documentoNombre, doc: file }) */

        this.files[this.rows.length] = ({ name: this.documentoNombre, doc: file })
        this.peso = (files.item(0).size / 1000000) + ' MB'

        this.checksSize(this.files.length - 1)

        this.revisarTabla()
      }
    }
    this.actualSizeFiles = this.actualSizeFiles + files.item(0).size
    this.rows1[0].total = this.actualSizeFiles
    this.rows1 = [...this.rows1];

    //check max size file
    this.checksSize(this.files.length - 1)

    this.revisarTabla()
  }




  checksSize(index = null) {
    if (this.actualSizeFiles > this.maxSizeFiles) {
      this.deleteFile(index)
      this.alertMaxsize()
    }
  }

  alertMaxsize() {
    swal({
      icon: 'error',
      title: 'Supero el máximo de MB para tus adjuntos',
      text: '<p>Usted cuenta con un máximo de <strong>25 MB</strong> para utilizar</p>',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false
    })
  }

  uploadAllfiles() {
    this.onActivate()
    this.spinner.show();


    if (this.esReitero) {
      console.log("Subida de archivos con uploadObsReitero")
      this._seguimientoService.uploadObsReitero(this.files, this.actReiteros).subscribe(
        response => {
          console.log(response)
          this.spinner.hide();
          var subidos = { "archivosSubidos": true };
          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          let alert = { icon: 'success', text: '', title: '' }

          if (response.success) {
            this.linkarchivos = "El archivo se ingreso en la base para reiteros"

            this.dialog.closeAll()
            alert.icon = 'success'
            alert.text = '<p><strong>' + response.msg + '<strong></p>'
            alert.title = 'Archivos cargados!'
          } else {
            alert.icon = 'error'
            alert.text = '<p><strong>' + response.msg + '<strong></p>'
            alert.title = 'Archivos no cargados'
          }

          swal({
            icon: alert.icon,
            title: alert.title,
            text: alert.text,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );

        },
        error => {

          console.log("un error", error);
          swal({
            icon: 'error',
            title: 'Error al subir documentación',
            text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );

        }
      )

    } else {
      console.log("Subida de archivos con uploadFilesObs")

      this._documentosServices.uploadFilesObs(this.files).subscribe(
        response => {
          console.log(response)
          this.linkarchivos = response.url
          this.spinner.hide();
          var subidos = { "archivosSubidos": true };
          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          let alert = { icon: 'success', text: '', title: '' }

          if (response.code == 99 && response.url) {
            alert.icon = 'success'
            alert.text = '<p>Puedes revisar una vez más tus documentos, usa el siguiente link <br><br> <a mat-stroked-button href="' + response.url + '" style="text-decoration=none" target="_blank"><strong>Descarga tus documentos<strong></a><br><br><br></p>'
            alert.title = 'Archivos cargados'
            localStorage.setItem('ZipURL', response.url)
          } else if (response.code == 98) {
            alert.icon = 'error'
            alert.text = '<p>No se adjuntaron documentos</p>'
            alert.title = 'Archivos no cargados'
          } else if (response.code == 97) {
            alert.icon = 'error'
            alert.text = '<p>No se adjuntaron documentos</p>'
            alert.title = 'Archivos no cargados'
          } else if (response.code == 96) {
            alert.icon = 'error'
            alert.text = '<p>Archivos no permitidos</p>'
            alert.title = 'Archivos no cargados'
          }
          else {
            alert.icon = 'error'
            alert.text = '<p>Hubo un problema al subir los documentos, intente más tarde</p>'
            alert.title = 'Archivos no cargados'
          }

          swal({
            icon: alert.icon,
            title: alert.title,
            text: alert.text,
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );

        },
        error => {
          this.spinner.hide();
          console.log("un error", error);
          var subidos = { "archivosSubidos": true };
          localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
          swal({
            icon: 'error',
            title: 'Error al subir documentación',
            text: '<p>Hubo un error al intentar subir los documentos, por favor intente más tarde</p>',
            showConfirmButton: true,
            confirmButtonText: 'Aceptar',
            allowOutsideClick: false
          }).then(
            () => {
              window.scrollTo(0, document.body.scrollHeight);
            }
          );
        }
      )

    }

  }


  deleteFile(files: FileList) {
    console.log(this.archivoCargado)
    if (this.archivoCargado) {


      //recalcular size
      let fil: File
      fil = this.files[this.files.length - 1]
      this.actualSizeFiles = (this.actualSizeFiles > 0) ? this.actualSizeFiles - fil.size : 0
      //Remove file
      this.files.splice(this.files.length - 1, 1)
      let actualRow = localStorage.getItem("adjuntos");
      console.log("this.files", this.files);
      this.archivoCargado = ''

    } else {
      /*   if (files.item(0).name) {
            this.files.splice(this.files.length - 1, 1)
            let actualRow = localStorage.getItem("adjuntos");
            console.log("this.files", this.files);
        } */
      this.btnAccept = false
      this.cerrarModal();
    }
  }

  deleteFile2(row) {
    var subidos = { "archivosSubidos": true };
    localStorage.setItem("archivos_marcados", JSON.stringify(subidos))
    console.log(row)
    this.rows.splice(row.id, 1)
    this.files.splice(row.id, 1)

    this.clearSize()
  }

  clearSize() {
    this.actualSizeFiles = 0
    console.log(this.files)
    for (let index = 0; index < this.files.length; index++) {
      const element = this.files[index];
      if (element) {
        this.actualSizeFiles = this.actualSizeFiles + element.doc.size
      }
    }
    //check max size file
    this.checksSize(this.files.length - 1)
  }

  buscar_observaciones() {
    this.onActivate()
    this.spinner.show()

    this.userService.get_observaciones(this.formderecho.controls.rut.value, this.formderecho.controls.expediente.value, this.formderecho.controls.solicitud.value).subscribe(resp => {
      this.buscando = false

      console.log("get_observaciones", resp)

      if (resp.status == "error") {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: resp.message,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      } else {
        if (resp.resp.data[0].fieldData.TCo_Acta_Fec_FInalizada) {
          this.spinner.hide()
          swal({
            type: 'warning',
            title: 'Atención!',
            text: "Proceso cerrado para ingreso de observaciones.",
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 3500
          }).then(() => {
          }, (dismiss) => {
            if (dismiss === 'timer') {
            }
          });
        } else {

          this.info_observacion = resp
          this.buscar_info_sol()

          this.fecha_noti = moment(this.info_observacion.resp.data[0].fieldData.TCo_Acta_depto).format("DD-MM-YYYY")
          this.fecha_crea = moment(this.info_observacion.resp.data[0].fieldData.TRAIN_Fecha_Creacion).format("DD-MM-YYYY")
          for (let i = 0; i < resp.resp.data[0].portalData['Tramite_Exp_Acta_Obs 2'].length; i++) {
            const element = resp.resp.data[0].portalData['Tramite_Exp_Acta_Obs 2'][i];
            this.observaciones.push(element)

          }
          console.log(this.observaciones)
          this.buscando = true
          this.spinner.hide()
          console.log(resp)
        }

      }

    }, error => {
      console.log(error)
    })
  }


  logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });


  }



  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  private docId() {
    let text = '';
    const possible = '0123456789';

    for (let i = 0; i < 8; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }


  volver() {
    this.esReitero = false
    this.buscando = false
    this.formderecho.controls.rut.value = ""
    this.formderecho.controls.expediente.value = ""
    this.formderecho.controls.solicitud.value = ""
    this.nuevo_sol_derecho = false
  }

  closeTab() {
    window.close();
  }


  buscar_info_sol() {
    this.onActivate()
    this.spinner.show()
    this.continuar = false
    console.log("buscando rut", this.formderecho.controls.rut.value)

    this.userService.traerInfo_rut(this.formderecho.controls.rut.value).subscribe(
      response => {
        this.rut_encontrado = false
        if (response) {

          this.info_rut = response
          console.log(this.info_rut)
          // this.primerPaso = true
          this.rut_encontrado = true
          this.spinner.hide()
        }
        console.log("continuar", this.continuar)
      }, error => {
        this.spinner.hide()
        console.log(error)
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "Ha ocurrido un error",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }
    )
  }

  finalizarIngreso() {
    this.onActivate()
    this.spinner.show()
    if (this.esReitero) {

      this.userService.ingreso_obs(this.id_soL, this.solicitudNum, this.glosa.value, this.linkarchivos, this.info_rut).subscribe(resp => {
        console.log(resp)
        this.spinner.hide()
        if (resp.code == "200") {
          swal({
            type: 'success',
            title: 'Ingresado',
            text: resp.message,
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 5000,
            onClose: () => {
              this.closeTab()
            }
          }).then(() => {
          }, (dismiss) => {
            if (dismiss === 'timer') {
            }
          });
        } else if (resp.code == "500") {
          swal({
            type: 'warning',
            title: 'Atención!',
            text: "Ha ocurrido un error",
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 5000,
            onClose: () => {
              this.closeTab()
            }
          }).then(() => {
          }, (dismiss) => {
            if (dismiss === 'timer') {
            }
          });
        }

      }, error => {
        console.log(error)
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "Ha ocurrido un error",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 5000,
          onClose: () => {
            this.closeTab()
          }
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      })
    } else {
      /* No viene desde reitero, proceso normal de observaciones */

      this.userService.ingreso_obs(this.info_observacion.resp.data[0].fieldData._Tex_ID_Solicitud, this.info_observacion.resp.data[0].fieldData._Tex_ID_materia_Solicitud_Proexsi_ano, this.glosa.value, this.linkarchivos, this.info_rut).subscribe(resp => {
        console.log(resp)
        this.spinner.hide()
        if (resp.code == "200") {
          swal({
            type: 'success',
            title: 'Ingresado',
            text: resp.message,
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 5000,
            onClose: () => {
              this.closeTab()
            }
          }).then(() => {
          }, (dismiss) => {
            if (dismiss === 'timer') {
            }
          });
        } else if (resp.code == "500") {
          swal({
            type: 'warning',
            title: 'Atención!',
            text: "Ha ocurrido un error",
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 5000,
            onClose: () => {
              this.closeTab()
            }
          }).then(() => {
          }, (dismiss) => {
            if (dismiss === 'timer') {
            }
          });
        }

      }, error => {
        console.log(error)
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "Ha ocurrido un error",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 5000,
          onClose: () => {
            this.closeTab()
          }
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      })
    }
  }
  onActivate() {
    window.scroll(0, 0);
  }


  buscar_observaciones_reitero() {
    this.onActivate()
    this.spinner.show()
    console.log(this.id_soL)
    console.log(this.actReiteros)


    this._seguimientoService.getObs_Reiteros(this.id_soL, this.actReiteros).subscribe(resp => {
      this.buscando = false

      console.log("getObs_Reiteros", resp)

      if (!resp.success) {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: resp.msg,
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      } else {
        /* if (resp.resp.data[0].fieldData.TCo_Acta_Fec_FInalizada) {
          this.spinner.hide()
          swal({
            type: 'warning',
            title: 'Atención!',
            text: "Proceso cerrado para ingreso de observaciones.",
            confirmButtonColor: '#3F51B5',
            confirmButtonText: 'Aceptar',
            timer: 3500
          }).then(() => {
          }, (dismiss) => {
            if (dismiss === 'timer') {
            }
          });
        } else { */

        this.info_observacion = resp
        this.buscar_info_sol()

        /*  this.fecha_noti = moment(this.info_observacion.resp.data[0].fieldData.TCo_Acta_depto).format("DD-MM-YYYY")
         this.fecha_crea = moment(this.info_observacion.resp.data[0].fieldData.TRAIN_Fecha_Creacion).format("DD-MM-YYYY") */
        for (let i = 0; i < resp.data.length; i++) {
          const element = resp.data[i];
          this.observaciones.push(element)

        }
        console.log(this.info_observacion)
        this.buscando = true
        this.spinner.hide()
        console.log(resp)
        /* } */

      }

    }, error => {
      console.log(error)
    })
  }

}
